











import Vue from 'vue';
import PAccordion from './p-accordion.vue';

type Accordion = InstanceType<typeof PAccordion>;

export default Vue.extend({
  name: 'PAccordionGroup',
  props: {
    staysOpen: { default: false, type: Boolean },
  },
  data: () => ({
    children: [] as Vue[],
    openAccordion: undefined as undefined | Accordion,
  }),
  methods: {
    onAccordionInput(accordion: Accordion, expandedCurrent: boolean, expandedPrevious: boolean) {
      if (expandedCurrent) {
        this.openAccordion = accordion;
      }
      if (this.openAccordion === accordion && !expandedCurrent) {
        if (this.staysOpen) {
          // Prevent closing accordion
          accordion.$emit('input', true);
        }
      }
      this.children.forEach((child) => {
        const currAccordion = child.$parent as Accordion;
        if (currAccordion === accordion || this.openAccordion === currAccordion) {
          return; // skip
        }
        if (currAccordion.expanded !== false) {
          currAccordion.$emit('input', false);
        }
      });
    },
    onRegisterAccordion(child: Vue) {
      const accordion = child.$parent as Accordion;
      accordion.$watch('value', (newValue: boolean, oldValue: boolean) => {
        this.onAccordionInput(accordion, newValue, oldValue);
      });
    },
  },

});
